import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import ItemSimple from '../Shared/ItemSimple'
import RideItem from './RideItem'
import TransportationSidebar from './TransportationSidebar'

import classes from '../Shared/Item.module.css'


const TransportationItem = ({itemData, apiCase, inWorkQ}) => {
    const activeCase = useSelector(state => state.case.activeCase)
    const rides = activeCase?.case_transportation?.rides
    const isMinorPatient = !!activeCase?.patient?.is_minor
   
    const rideData = useMemo(() => {
        if (!Array.isArray(rides)) {
            return null
        }
        return [...rides].sort((x, y) => {
            const tx = x.date ? new Date(x.date).getTime() : 0
            const ty = y.date ? new Date(y.date).getTime() : 0
            if (ty !== tx) {
                return ty - tx
            }
            return x.active === y.active ? 0 : x.active ? -1 : 1
        })
    }, [rides])

    return <ItemSimple data={itemData} mainItem={null} type={'case_transportation'} folder={'case_transportation'}>
        <div className={classes.item_inner}>
            <div className={classes.item_left}>               
                <div className={classes.items_overflow_container}>
                    {rideData && rideData.length > 0 && <>
                        <table>
                            <thead>
                                <tr>
                                    <th>Lyft Ride ID</th>
                                    <th>Lyft Ride Status</th>
                                    <th>Date</th>
                                    <th>From</th>
                                    <th>To</th>
                                    <th>Route URL</th>
                                    <th>Distance</th>
                                    <th>Trip Charge</th>
                                    <th>Lyft Charge</th>
                                    <th>Shared</th>
                                    {isMinorPatient && <th>Guardian Name</th>}
                                    {isMinorPatient && <th>Guardian Relationship</th>}
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rideData.map(item => (
                                    <RideItem key={item.id} item={item} isMinorPatient={isMinorPatient}/>
                                ))}
                            </tbody>
                        </table>
                        
                    </>}
                </div>
            </div>     
            <div className={classes.item_right}>               
                <TransportationSidebar data={itemData} apiCase={apiCase} inWorkQ={inWorkQ}/>
            </div>              
        </div> 
    </ItemSimple>
}

export default TransportationItem